<template>
  <div class="px-3 pb-7 pt-2 h-full">
    <VariableSelect v-model="config.variable" label="Assign to Variable" class="flex-grow" :filter-data-type="['Text']" @update:modelValue="emitPayload" />
    <PhraseEditor v-model="config.key" label="Secret Key" :items="variables" class="mt-3 flex-grow" @update:modelValue="emitPayload" />
    <PhraseEditor v-model="config.payload" label="Payload" :items="variables" class="mt-3 flex-grow" @update:modelValue="emitPayload" />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import EvaluateItemsConfig from '@/components/flow/evaluate/EvaluateItemsConfig';
import debounce from '../../../helpers/debounce';
import uuidv4 from '../../../helpers/uuid';

export default {
  name: 'AESEncryptConfig',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      config: structuredClone(EvaluateItemsConfig['crypto-aes-encrypt'].payload),
    };
  },
  created() {
    this.setInitialData(structuredClone(this.item.payload));
  },
  computed: {
    ...mapState(['projectData']),
    payload() {
      return {
        id: this.item.id,
        type: this.item.type,
        payload: structuredClone(this.config),
      };
    },
    projectId() {
      return this.$route.params.projectId;
    },
    variables() {
      let variables = [];
      if (this.projectId && Object.keys(this.projectData).length) {
        variables = Object.keys(this.projectData?.[this.projectId]?.variables || {}).sort((a, b) => a.toLowerCase().localeCompare(b.toLowerCase())) || [];
      }
      variables = variables.map((variable) => ({
        id: uuidv4(),
        value: variable,
      }));
      return variables;
    },
  },
  methods: {
    // eslint-disable-next-line
    emitPayload: debounce(function () {
      this.$emit('update', structuredClone(this.payload));
    }, 300),
    setInitialData(responseData) {
      this.config = structuredClone({ ...this.config, ...responseData });
    },
  },
};
</script>
